export abstract class StaticElement {

  //field_type = {1: Text, 2: List, 3: Date, 4: Numeric, 5: Boolean}
  public static field_type = [
    { id: 1, name: 'Texto', icon: 'typcn-sort-alphabetically-outline' },
    { id: 2, name: 'Lista', icon: 'typcn-th-list-outline' },
    { id: 3, name: 'Fecha', icon: 'typcn-calendar-outline' },
    { id: 4, name: 'Numérico', icon: 'typcn-sort-numerically-outline' },
    { id: 5, name: 'Binario', icon: 'typcn-input-checked-outline' }
  ];

  //state= {0: Inactive, 1: Active}
  public static state = [
    { id: 1, name: 'Activo', color: '#2EB231' },
    { id: 0, name: 'Inactivo', color: '#9E9E9E' }
  ];

  //targeting
  public static targeting = [
    { id: 1, name: 'Activo' },
    { id: 0, name: 'Inactivo' }
  ];

  //replication
  public static replication = [
    { id: 1, text: 'Si' },
    { id: 0, text: 'No' }
  ];

  //newsletter
  public static newsletter = [
    { id: 1, name: 'Activo' },
    { id: 0, name: 'Inactivo' }
  ];

  //gender
  public static sex = [
    { id: 'female', name: 'Mujer' },
    { id: 'male', name: 'Hombre' }
  ];

  //role_type
  public static role_type = [
    { id: 1, name: 'Interno' },
    { id: 2, name: 'Cliente' }
  ];

  //email_confirmed
  public static email_confirmed = [
    { id: 1, name: 'Confirmado' },
    { id: 0, name: 'No confirmado' }
  ];

  //{1: usuario, 2: demografico, 3: navegacion, 4: evento}
  public static segment_type = [
    { id: 1, name: 'Usuario' },
    { id: 2, name: 'Demográfico' },
    { id: 3, name: 'Navegación' },
    { id: 4, name: 'Evento' }
  ];

  //{1: es igual a, 2: es diferente de, 3: existe en, 4: entre(fecha)}
  public static segment_condition = [
    { id: 1, name: 'Igual a' },
    { id: 2, name: 'Diferente a' },
    { id: 3, name: 'Coincide' },
    { id: 4, name: 'Entre' },
    { id: 5, name: 'Mayor que' },
    { id: 6, name: 'Menor que' }
  ];

  public static field_user = [
    { id: 'user_country_state', name: 'Departamento' },  //table dmp_country_state -> idcountry_state
    { id: 'user_gender', name: 'Sexo' }, //table dmp_user_site -> gender
    { id: 'user_age', name: 'Edad' },  //table dmp_user_site -> DATE(now()) - DATE(birthdate)
    { id: 'user_birthdate', name: 'Fecha de nacimiento' }, //table dmp_user_site -> birthdate
    { id: 'user_newsletter', name: 'Newsletter' }  //table dmp_user_site -> newsletter
  ];

  public static field_user_gender = [
    { id: 'female', name: 'Femenino' },
    { id: 'male', name: 'Masculino' }
  ];

  public static field_user_newsletter = [
    { id: "1", name: 'Activo' },
    { id: "0", name: 'Inactivo' }
  ];

  public static field_navigation = [
    { id: 'navi_url', name: 'URL' },  //table dmp_user_site_pageview -> url
    { id: 'navi_title', name: 'Título' }, //table dmp_user_site_pageview -> title
    { id: 'navi_section', name: 'Sección' },  //table dmp_section_site -> name
    { id: 'navi_topic', name: 'Tema' }, //table dmp_topic_site -> name
    { id: 'navi_keyword', name: 'Palabra clave' }  //table dmp_user_site_pageview -> keywords
  ];

  public static field_demographic_boolean = [
    { id: "0", name: 'No' },
    { id: "1", name: 'Si' },
  ];

  public static field_behaviour = [
    { id: 'behav_category', name: 'Categoría' },  //table dmp_user_site_event -> category
    { id: 'behav_title', name: 'Título' }, //table dmp_user_site_pageview -> title
    { id: 'behav_section', name: 'Sección' },  //table dmp_section_site -> name
    { id: 'behav_topic', name: 'Tema' }, //table dmp_topic_site -> name
    { id: 'behav_keyword', name: 'Palabra clave' }  //table dmp_user_site_pageview -> keywords
  ];

  //dimiss
  public static dimiss = [
    { id: 1, name: 'Si' },
    { id: 0, name: 'No' }
  ];

  public static user_segment_by = [
    { id: 0, name: 'General' },
    { id: 1, name: 'Estado' },
    { id: 2, name: 'Sexo' },
    { id: 3, name: 'Newsletter' }
  ];

  public static user_group_by = [
    { id: 'YYYY', name: 'Año' },
    { id: 'YYYY-MM', name: 'Año - Mes' },
    { id: 'YYYY-MM-DD', name: 'Año - Mes - Día' }
  ];

  public static filter_period = [
    { id: 1, name: 'Personalizado' },
    { id: 2, name: 'Hoy' },
    { id: 3, name: 'Ayer' },
    { id: 4, name: 'La semana pasada' },
    { id: 5, name: 'El mes pasado' },
    { id: 6, name: 'Últimos 7 días' },
    { id: 7, name: 'Últimos 30 días' }
  ];

  public static filter_group_by = [
    { id: 'YYYY', name: 'Año' },
    { id: 'YYYY-MM', name: 'Año - Mes' },
    { id: 'YYYY-MM-DD', name: 'Año - Mes - Día' }
  ];

  public static sync_state = [
    { id: 2, name: 'Sincronizado', class: 'badge-success', color: '#3BB000' },
    { id: 1, name: 'Pendiente', class: 'badge-warning', color: '#FAC106' },
    { id: 0, name: 'No sincronizado', class: 'badge-danger', color: '#9E9E9E' }
  ];

  //state = {0: inactive, 1: active, 2: realized, 3: cancelled}
  public static state_promotion = [
    { id: 1, name: 'Activa', class: 'badge-success', color: '#3BB000' },
    { id: 0, name: 'Inactiva', class: 'badge-danger', color: '#9E9E9E' },
    { id: 3, name: 'Cancelada', class: 'badge-warning', color: '#FAC106' },
    { id: 2, name: 'Realizada', class: 'badge-info', color: '#2FA2B8' }
  ];

  //state = {0: inactive, 1: active, 2: realized, 3: cancelled}
  public static state_promotion_select = [
    { id: 1, name: 'Activa' },
    { id: 0, name: 'Inactiva' },
    { id: 3, name: 'Cancelada' }
  ];

  //orientation = {1: obtain, 2: maintain}
  public static orientation_promotion = [
    { id: 1, name: 'Obtener usuarios' },
    { id: 2, name: 'Mantener usuarios' }
  ];

  //participation_criteria = {1: data, 2: time, 3: pageview, 4: recommendation, 5: newsletter}
  public static participation_criteria_promotion = [
    { id: 1, name: 'Proporcionar datos' },
    { id: 2, name: 'Tiempo navegando' },
    { id: 3, name: 'Páginas vistas' },
    /* { id: '4', name: 'Recomendación de usuarios' },
    { id: '5', name: 'Interacción con newsletter' } */
    { id: 6, name: 'Interacción' },
  ];

  public static filter_period_promotion = [
    { id: 1, name: 'Durante la promoción' },
    { id: 2, name: 'Hoy' },
    { id: 3, name: 'Ayer' },
    { id: 4, name: 'La semana pasada' },
    { id: 5, name: 'El mes pasado' },
    { id: 6, name: 'Últimos 7 días' },
    { id: 7, name: 'Últimos 30 días' }
  ];

  //dmp_format - type = {0: display, 1: rich media, 2: video}
  public static format_type = [
    { id: 1, name: 'Rich Media', class: 'badge-primary' },
    { id: 0, name: 'Display', class: 'badge-info' },
    { id: 2, name: 'Video', class: 'badge-secondary' }
  ];

  //dmp_format - platform = {0: mobile, 1: desktop}
  public static format_platform = [
    { id: 0, name: 'Mobile', class: 'badge-info' },
    { id: 1, name: 'Desktop', class: 'badge-primary' }
  ];


  //Es usuario administrador
  public static is_admin_user = [
    { id: 1, name: 'Administrador' },
    { id: 0, name: 'Estándar' }
  ];


  //Tipos de formatos para un arte
  public static format_type_variable = [
    { id: 0, name: 'Imagen_url', icon: 'typcn-image' },
    { id: 1, name: 'Sound_url', icon: 'typcn-notes-outline' },
    { id: 2, name: 'Link', icon: 'typcn-attachment-outline' },
    { id: 3, name: 'Text', icon: 'typcn-sort-alphabetically-outline' }
  ];

  //art_price_priority {4: alta, 6: standard_6, 8: standard_8, 10: standard_10}
  public static art_price_priority = [
    { id: 4, name: 'Alta', class: 'badge-primary' },
    { id: 6, name: 'Estándar Alta', class: 'badge-dark' },
    { id: 8, name: 'Estándar Media', class: 'badge-secondary' },
    { id: 10, name: 'Estándar Baja', class: 'badge-light' }
  ];

  //campaign_objective  {0: traffic, 1: click, 2: interaction, ect.}
  public static campaign_objective = [
    { id: 0, name: 'traffic' },
    { id: 1, name: 'click' },
    { id: 2, name: 'interaction' }
  ];

  //campaign_state {0: Creada, Lista, En curso, ect.}
  // public static campaign_state = [
  //   { id: '0', name: 'Creada', class: "bg_campaign_state_created", color: '#FFE599' },
  //   { id: '1', name: 'Lista', class: "bg_campaign_state_ready", color: '#A9C4EB' },
  //   { id: '2', name: 'En curso', class: "bg_campaign_state_in_progress", color: '#B9E0A5' },
  //   { id: '3', name: 'En pausa', class: "bg_campaign_state_in_pause", color: '#E6E6E6' },
  //   { id: '4', name: 'Cancelada', class: "bg_campaign_state_in_canceled", color: '#F19C99' },
  //   { id: '5', name: 'En modificación', class: "bg_campaign_state_in_update", color: '#CDA2BE' },
  //   { id: '6', name: 'Finalizada', class: "bg_campaign_state_finished", color: '#9AC7BF' }
  // ];
  public static campaign_state = [
    { id: 0, name: 'Creada', class: "bg_campaign_state_created", color: '#F0D661' },
    { id: 1, name: 'Lista', class: "bg_campaign_state_ready", color: '#2779C0' },
    { id: 2, name: 'En curso', class: "bg_campaign_state_in_progress", color: '#92d601' },
    { id: 3, name: 'En pausa', class: "bg_campaign_state_in_pause", color: '#E6E6E6' },
    { id: 4, name: 'Cancelada', class: "bg_campaign_state_in_canceled", color: '#F19C99' },
    { id: 5, name: 'En modificación', class: "bg_campaign_state_in_update", color: '#ED4A79' },
    { id: 6, name: 'Finalizada', class: "bg_campaign_state_finished", color: '#9AC7BF' }
  ];


  public static campaign_state_created = [
    { id: 0, name: 'Creada' },
    { id: 1, name: 'Lista' },
    { id: 4, name: 'Cancelada' }
  ];

  public static campaign_state_ready = [
    { id: 1, name: 'Lista' },
    { id: 2, name: 'En curso' },
    { id: 5, name: 'En modificación' }
  ];

  public static campaign_state_in_progress = [
    { id: 2, name: 'En curso' },
    { id: 3, name: 'En pausa' }
  ];

  public static campaign_state_in_pause = [
    { id: 3, name: 'En pausa' },
    { id: 1, name: 'Lista' },
    { id: 5, name: 'En modificación' },
    { id: 4, name: 'Cancelada' }
  ];

  public static campaign_state_in_update = [
    { id: 5, name: 'En modificación' },
    { id: 1, name: 'Lista' },
    { id: 4, name: 'Cancelada' }
  ];

  public static campaign_state_canceled = [
    { id: 4, name: 'Cancelada' }
  ];

  public static campaign_state_finished = [
    { id: 6, name: 'Finalizada' }
  ];

  //Formatos de Archivo
  public static format_file = [
    { id: 'png', name: 'PNG' },
    { id: 'jpeg', name: 'JPEG' },
    { id: 'jpg', name: 'JPG' },
    { id: 'gif', name: 'GIF' },
    { id: 'mp3', name: 'MP3' },
    { id: 'm4r', name: 'm4r' },
    { id: 'mp4', name: 'MP4' }
  ];

  //Formatos de Imagen
  public static format_image = [
    { id: 'png', name: 'PNG' },
    { id: 'jpeg', name: 'JPEG' },
    { id: 'jpg', name: 'JPG' },
    { id: 'gif', name: 'GIF' }

  ];
  //Formatos de Imagen
  public static format_video = [
    { id: 'm4r', name: 'm4r' },
    { id: 'mp4', name: 'MP4' }

  ];

  //Formatos de Audio
  public static format_audio = [
    { id: 'mp3', name: 'MP3' }
  ];

  //line_item_state {DELIVERING: Entregando, READY: Lista, ect.}
  public static line_item_state = [
    { code: 'READY', name: 'Listo', class: "bg_campaign_state_ready" },
    { code: 'DELIVERING', name: 'Entregando', class: "bg_campaign_state_in_progress" },
    { code: 'PAUSED', name: 'En pausa', class: "bg_campaign_state_in_pause" },
    { code: 'CANCELED', name: 'Cancelada', class: "bg_campaign_state_in_canceled" },
    { code: 'COMPLETED', name: 'Finalizado', class: "bg_campaign_state_finished" },
    { code: 'INACTIVE', name: 'Inactivo', class: "bg_campaign_state_inactive" }
  ]

  // goal_unit_type {IMPRESSIONS: Impresiones, etc}
  public static goal_unit_type = [
    { code: 'IMPRESSIONS', name: 'Impresiones' }
  ]

  //campaaing is filed 
  public static filed = [
    { id: 1, name: 'Si' },
    { id: 0, name: 'No' }
  ];

  //navegations accions
  public static navegation_type = [
    { type: 'event', name: 'Evento', class: 'badge-warning' },
    { type: 'session', name: 'Sesión', class: 'badge-info' },
    { type: 'pageview', name: 'Página vista', class: 'badge-success' }
  ];

  //type user
  public static user_type = [
    { id: 'registered', name: 'Registrado', class: 'badge-info' },
    { id: 'anonymus', name: 'Anónimo', class: 'badge-secondary' }
  ];

  //Art_category_type {1: sale, 2: device, 3: position, 4: format, 5: size, 6: type}
  public static art_category_type = [
    { id: 1, name: 'Venta', color: '#FF4500' },
    { id: 2, name: 'Dispositivo', color: '#4682B4' },
    { id: 3, name: 'Posición', color: '#32CD32' },
    { id: 4, name: 'Formato', color: '#FFD700' },
    { id: 5, name: 'Tamaño', color: '#8A2BE2' },
    { id: 6, name: 'Tipo', color: '#A52A2A' }
  ];

  //Displayable {mostrar en vista de elemento multimedia, 1=si, 2=no}
  public static displayable = [
    { id: 1, text: 'Si' },
    { id: 2, text: 'No' }
  ];

  //Mail_list {1: editorial, 2: segmentada, 3: variable}
  public static type_list = [
    { id: 'all', name: 'Todos' },
    { id: 1, name: 'Editorial', color: '#42A5F5' },
    { id: 2, name: 'Segmentada', color: '#66BB6A' },
    { id: 3, name: 'Variable', color: '#FFA726' }
  ];

  //Mail_campaign_state 
  public static mail_campaign_state = [
    { id: 1, name: 'Borrador', color: '#B0BEC5', icon: 'ion-ios-create' },
    { id: 2, name: 'Lista', color: '#42A5F5', icon: 'ion-ios-list-box' },
    { id: 3, name: 'Enviando', color: '#FFA726', icon: 'ion-ios-send' },
    { id: 4, name: 'Enviado', color: '#66BB6A', icon: 'ion-ios-checkmark-circle' },
    { id: 5, name: 'Cancelada', color: '#EF5350', icon: 'ion-ios-close-circle' },
    { id: 6, name: 'Programado', color: '#7E57C2', icon: 'ion-ios-time' }
  ];

  //Art_category_type {1: artículo dinámico, 2: artículo estático, 3: imagen, 4: html}
  public static mail_campaign_body_type = [
    { id: 1, name: 'Artículo dinámico', color: '#42A5F5', icon: "typcn-refresh-outline" },
    { id: 2, name: 'Artículo estático', color: '#B0BEC5', icon: "typcn-document-text" },
    { id: 3, name: 'Imagen', color: '#66BB6A', icon: "typcn-image-outline" },
    { id: 4, name: 'Html', color: '#FFA726', icon: "typcn-code-outline" }
  ];

  //Mail_style_items 
  public static mail_style_items = [
    { id: 1, name: 'Predeterminado', color: '#42A5F5' },
    { id: 2, name: 'Cómodo', color: '#66BB6A' },
    { id: 3, name: 'Compacto inferior', color: '#FFA726' },
    { id: 4, name: 'Campacto superior', color: '#8E24AA' }
  ];

  //Static item for body of campaign
  public static mail_static_item = [
    { key: 'title', label: 'Título', type: 'text' },
    { key: 'image', label: 'Url de la imagen', type: 'text' },
    { key: 'section', label: 'Sección', type: 'text' },
    { key: 'section_url', label: 'Url sección', type: 'text' },
    { key: 'author', label: 'Autor', type: 'text' },
    { key: 'url', label: 'Url', type: 'text' },
  ];

  //Image item for body of campaign
  public static mail_image_item = [
    { key: 'image', label: 'Url de la imagen', type: 'text' },
    { key: 'description', label: 'Descripción', type: 'text' },
    { key: 'url', label: 'Url', type: 'text' },
  ];
}